import { GetServerSideProps, NextPage } from 'next';
import Link from 'next/link';
import Layout from '@lib/view/components/layout';
import APP_CONFIG from '@constants/APP_CONFIG';

const { EMAIL_CONTACT } = APP_CONFIG;

const TermAndConditionsVM: NextPage<{}> = () => {
    return (
        <Layout className={''} classHeader="header-shadow">
            <div className="md:container md:mx-auto px-4 md:px-35px mx-auto pt-10 pb-4 mb-10 border border-t-0">
                <div className="md:container  md:mx-auto">
                    <div className="border-rouded">
                        <h1 className="font-bold text-2xl md:text-30px mb-4 text-green-cyprus">
                            Refund policy
                        </h1>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Introduction
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    We, record pals limited, understand that
                                    there may be exceptional circumstances where
                                    a refund is necessary. This refund policy
                                    (&quot;policy&quot;) explains our policy for
                                    issuing refunds for the products and
                                    services provided on our website,{' '}
                                    <Link href="/">
                                        <a>{APP_CONFIG.SITE_URL}</a>
                                    </Link>{' '}
                                    (the &quot;website&quot;).
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Non-refundable items
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - Please note that we offer non-tangible
                                    irrevocable goods, so we do not issue
                                    refunds once the order is accomplished and
                                    the content that has been written was sent
                                    to you. As a customer, you are responsible
                                    for understanding this upon purchasing any
                                    item on our site.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Refundable items
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    1. We may issue a refund for the following
                                    reasons:
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    2. Non-delivery of the product:
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - In some cases, the process times may be
                                    slower and it may take a little longer for
                                    your orders to be completed if our team is
                                    very busy. In this case, we recommend
                                    contacting us for assistance via{' '}
                                    <a href={`mailto:${EMAIL_CONTACT}`}>
                                        {APP_CONFIG.EMAIL_CONTACT}
                                    </a>
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Claims for non-delivery must be submitted
                                    to our support department in writing within
                                    5 days from the order placing date.
                                    Otherwise, the campaign will be considered
                                    completed.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    3. Product not-as-described:
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - such issues should be reported to our
                                    support department within 3 days from the
                                    date of the purchase.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Clear evidence must be provided proving
                                    that the purchased product is not as it is
                                    described on the website.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - Complaints which are based merely on the
                                    customers false expectations or wishes are
                                    not honored. Our support team is always
                                    eager to assist you and deliver highly
                                    professional support in a timely manner.
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - All products are sold as is. The customer
                                    assumes the responsibility for the purchase,
                                    and no refunds will be issued.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Refund process
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    1. If you are eligible for a refund, please
                                    contact our support department at{' '}
                                    <a href={`mailto:${EMAIL_CONTACT}`}>
                                        {APP_CONFIG.EMAIL_CONTACT}
                                    </a>{' '}
                                    and provide the following information:
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - your order number
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - the reason for the refund request
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-8">
                                    - any relevant evidence to support your
                                    claim
                                </li>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus pl-4 tracking-wider">
                                    2. Our support team will review your request
                                    and issue a refund if it is deemed
                                    necessary.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Changes to this policy
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - We may update this policy from time to
                                    time. If we make changes, we will provide
                                    you with notice of such changes, such as by
                                    sending you an email or by posting a notice
                                    on the website. Your continued use of the
                                    website following the posting of changes to
                                    this policy means you accept the changes.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Contact us
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    - If you have any questions or concerns
                                    regarding this policy or the website, please
                                    contact us at [insert your contact
                                    information such as email address and phone
                                    number].
                                </li>
                            </ul>
                        </div>
                        <div className="pt-4" id="refund">
                            <h2 className="text-xl text-blue-royal mb-4 font-bold">
                                Conclusion
                            </h2>
                            <ul>
                                <li className="text-sm leading-6 mb-2 md:text-base text-green-cyprus">
                                    By using the website, you agree to the terms
                                    of this policy. If you do not agree to this
                                    policy, you must not use the website.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default TermAndConditionsVM;

export const getServerSideProps: GetServerSideProps = async (): Promise<{
    props: { title: string };
}> => {
    return {
        props: {
            title: 'T&C & Refund Policy',
        },
    };
};
